
const Weber = async (weber, handleDone) => {
    let data = {
        weber: weber,
    };
    var requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      };
    var response = await fetch(`${process.env.REACT_APP_BACKEND_ENDPOINT}/weber`, requestOptions)

    let result = await response.json();
    handleDone(result);
    return result;
}

export default Weber;